module.exports = __webpack_public_path__ + "static/media/risk-purple.e9e7896b.svg";